import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'

import Item from './components/item'
import { FaqEl } from './elements'

const Faq = ({ data }) => {
  const [active, setActive] = useState(-1)

  useEffect(() => {
    setActive(-1)
  }, [])

  return (
    <FaqEl>
      {data.map(({ question, answer }, i) => (
        <Item
          /* eslint-disable-next-line react/no-array-index-key */
          key={`item-${i}`}
          answer={answer}
          isActive={active === i}
          question={question}
          toggleActive={() => setActive(active !== i ? i : -1)}
        />
      ))}
    </FaqEl>
  )
}

export default Faq

Faq.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      answer: PropTypes.arrayOf(PropTypes.string).isRequired,
      question: PropTypes.string.isRequired,
    }),
  ).isRequired,
}
